import { useMemo } from 'react';
import { usePermissions } from 'context/PermissionsContext';
import { TASKS_PERMISSION_CODES } from 'permissions/constants/tasksPermissionCodes';
import { MODULE_KEY_MAP } from 'permissions/constants/moduleKeyMap';

export { TASKS_PERMISSION_CODES };

const usePermissionsTasks = () => {
  const { permissionsLoading, hasPermission, hasModuleAccess } =
    usePermissions();

  return useMemo(
    () => ({
      loading: permissionsLoading,
      canAccessModule: hasModuleAccess(MODULE_KEY_MAP.TASKS),
      canViewDetail: hasPermission(TASKS_PERMISSION_CODES.VIEW_DETAIL_TASKS),
      canPublishComment: hasPermission(TASKS_PERMISSION_CODES.PUBLISH_COMMENT),
      canAttachFileToComment: hasPermission(
        TASKS_PERMISSION_CODES.ATTACH_FILE_TO_COMMENT
      ),
      canGoToAssociatedCase: hasPermission(
        TASKS_PERMISSION_CODES.GO_TO_ASSOCIATED_CASE
      ),
      canChangeStatus: hasPermission(TASKS_PERMISSION_CODES.CHANGE_STATUS),
      canEditDocument: hasPermission(TASKS_PERMISSION_CODES.EDIT_DOCUMENT),
      canRemoveAssignedPerson: hasPermission(
        TASKS_PERMISSION_CODES.REMOVE_ASSIGNED_PERSON
      ),
      canDownloadExcel: hasPermission(TASKS_PERMISSION_CODES.DOWNLOAD_EXCEL),
      canCreateTasks: hasPermission(TASKS_PERMISSION_CODES.CREATE_TASKS),
      canViewSection: hasPermission(TASKS_PERMISSION_CODES.VIEW_SECTION),
    }),
    [permissionsLoading, hasPermission, hasModuleAccess]
  );
};

export default usePermissionsTasks;
